import type { ActiveAnalysis } from "./useActiveAnalysesStream";
import type { QuantityIndex } from "./useQuantities";

export function missingInputQuantities(analysis: ActiveAnalysis, quantityIndex: QuantityIndex) {
  return analysis.missingQuantityIds.flatMap(qId => {
    const quantity = quantityIndex[qId];
    return quantity ? [quantity.name] : [];
  });
}
